module.exports = __webpack_public_path__ + "2664147312b16a6107faad654765fc5b.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/content/assets/Slideshow_02.jpg
// module id = 622
// module chunks = 0